import { FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-white text-black font-light py-6 px-7 shadow-lg">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center md:text-left">
          
          {/* About Section */}
          <div>
            <h2 className="text-xl font-semibold">About Us</h2>
            <p className="text-sm mt-2">
              Waiiona Online Marketing is a Malawian eCommerce platform offering unique digital marketing, branding, and design services alongside a variety of physical and digital products through our store at <a href="https://waiiona.store" className="underline text-blue-600" target="_blank" rel="noopener noreferrer">waiiona.store</a>.
            </p>
          </div>

          {/* Our Products */}
          <div className="items-center justify-center">
            <h2 className="text-xl font-semibold text-center">Our Products</h2>
            <ul className="mt-2 space-y-2 flex flex-col items-center justify-center text-black text-sm">
              <li><a href="/products/electronics" className="hover:text-gray-300 no-underline text-black">Electronics</a></li>
              <li><a href="/products/fashion" className="hover:text-gray-300 no-underline text-black">Fashion & Apparel</a></li>
              <li><a href="/products/home-appliances" className="hover:text-gray-300 no-underline text-black">Home Appliances</a></li>
              <li><a href="/products/stationery" className="hover:text-gray-300 no-underline text-black">Stationery & Office</a></li>
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <h2 className="text-xl font-semibold">Contact Us</h2>
            <p className="mt-2 text-sm">Email: support@waiiona.store</p>
            <p className="text-sm">Phone: +265 987 516 467</p>
            <div className="flex justify-center items-center mt-3 text-black space-x-4">
              <a href="https://www.facebook.com/waiiona" className="text-black hover:text-gray-900" target="_blank" rel="noopener noreferrer">
                <FaFacebook size={24} />
              </a>
              <a href="https://twitter.com/waiiona" className="text-black hover:text-gray-700" target="_blank" rel="noopener noreferrer">
                <FaTwitter size={24} />
              </a>
              <a href="https://www.linkedin.com/company/waiiona" className="text-black hover:text-gray-900" target="_blank" rel="noopener noreferrer">
                <FaLinkedin size={24} />
              </a>
            </div>
          </div>

        </div>

        {/* Copyright */}
        <div className="text-center mt-6 text-sm border-t border-gray-700 pt-4">
          &copy; {new Date().getFullYear()} Waiiona Online Marketing. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
